<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import {
  getNameFilter,
  // getBrandFilter,
  getDomainFilter,
  getTenantFilter,
  getCreatedAtFilter,
} from '@/utils/common/tableFilter'
import ColumnsMixin from '../mixins/columns'
import SingleActionMixin from '../mixins/singleActions'
import { STATUS } from '../constants'

export default {
  name: 'BillBudgetList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'budgets',
        apiVersion: 'v1',
        getParams: this.getParams,
        filterOptions: {
          name: getNameFilter(),
          // brand: getBrandFilter(),
          status: {
            label: this.$t('common.status'),
            dropdown: true,
            items: STATUS.map(v => {
              return {
                label: v.value,
                key: v.key,
              }
            }),
          },
          projects: getTenantFilter(),
          project_domains: getDomainFilter(),
          created_at: getCreatedAtFilter(),
          // cloudaccount: {
          //   label: this.$t('res.cloudaccount'),
          //   dropdown: true,
          //   multiple: true,
          //   distinctField: {
          //     type: 'extra_field',
          //     key: 'cloudaccount',
          //   },
          //   hidden: () => this.$store.getters.isProjectMode,
          // },
          // region: {
          //   label: this.$t('res.region'),
          //   dropdown: true,
          //   distinctField: {
          //     type: 'extra_field',
          //     key: 'region',
          //   },
          // },
        },
        hiddenColumns: ['brand', 'account', 'cloudprovider_name', 'region', 'resource_type'],
      }),
      groupActions: [
        {
          label: this.$t('bill.text_193'),
          permission: 'bill_budgets_create',
          action: () => {
            this.$router.push({
              path: '/budget/create',
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('common.delete'),
          permission: 'bill_budgets_delete',
          action: () => {
            const data = this.list.selectedItems
            this.createDialog('DeleteResDialog', {
              vm: this,
              data,
              columns: this.columns,
              title: this.$t('common.delete'),
              name: this.$t('bill.budget'),
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              validate: this.list.selectedItems.length > 0,
            }
          },
        },
      ],
      exportDataOptions: {
        items: [
          { label: this.$t('bill.text_88'), key: 'name' },
          { label: this.$t('bill.text_89'), key: 'status' },
          { label: this.$t('bill.budget_period_type'), key: 'period_type' },
          { label: this.$t('bill.budget_currency'), key: 'currency' },
          { label: this.$t('bill.budget_amount'), key: 'amount' },
          { label: this.$t('common.text00119'), key: 'start_date' },
          { label: this.$t('common.text00120'), key: 'end_date' },
          { label: this.$t('common.createdAt'), key: 'created_at' },
          { label: this.$t('bill.text_81'), key: 'brand' },
          { label: this.$t('bill.text_60'), key: 'cloudaccount' },
          { label: this.$t('bill.text_233'), key: 'cloudprovider_name' },
          { label: this.$t('bill.text_83'), key: 'region' },
          { label: this.$t('bill.text_73'), key: 'resource_type' },
          { label: this.$t('bill.budget_project'), key: 'project_domain' },
          { label: this.$t('table.title.tag'), key: 'metadata' },
        ],
      },
    }
  },
  created () {
    this.fetchData()
    this.$bus.$on('budgetListRefresh', (val) => {
      this.list.refresh()
    })
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BudgetListSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
      })
    },
  },
}
</script>
